export default __webpack_public_path__ + "static/icon-31-1-a69a77bbfbe12a668cf4c4a68ac60188.png";